module.exports = __webpack_public_path__ + "img/hcpRegister.be66d706.svg";